export default function SearchBar() {
  return (
    <div className="ad-search-wrap">
      <input
        type="text"
        placeholder="Search roles..."
        className="ad-search-input"
      />
    </div>
  );
}